import { round } from 'lodash-es';
import { dataSourceWholeItems } from '@/resources/data-source';
import { Shape } from '@/services/shape';
import { buildAstState } from '..';

export const getRealSourceKey = (key: string) => {
  return key == 'time'
    ? 'timeHour'
    : key == 'dualtime'
    ? 'dualtimeHour'
    : key == 'weatherCurrentSunRise'
    ? 'weatherCurrentSunRiseHour'
    : key == 'weatherCurrentSunSet'
    ? 'weatherCurrentSunSetHour'
    : key;
};

export const mmHgToKpa = (val: number) => {
  const val2 = Math.max(0, Math.min(40, round((val * 4) / 30, 1)));
  return val2;
};

export const kPaToMmHg = (val: number) => {
  const val2 = Math.max(0, Math.min(300, round((val * 30) / 4, 0)));
  return val2;
};

export const celsiusToFahrenheit = (val: number) => {
  const val2 = Math.max(-147, Math.min(211, round(val * 1.8 + 32, 0)));
  return val2;
};
export const fahrenheitToCelsius = (val: number) => {
  const val2 = Math.max(-99, Math.min(99, round((val - 32) / 1.8, 0)));
  return val2;
};

/**
 * 获取另一个单位的值或者数据源key
 * @param val
 * @param mainSourceKey
 * @returns
 */
export const getSourceValueArr = (
  val: number | string,
  mainSourceItem?: DataSourceItem
) => {
  const isMultiUnit = mainSourceItem?.tag == 'compound';
  const mainSourceKey = mainSourceItem?.key;
  // 如果多单位则返回2个元素，否则返回1个元素
  if (typeof val == 'number') {
    return isMultiUnit
      ? [
          val,
          mainSourceKey?.includes('Temperature')
            ? celsiusToFahrenheit(val)
            : mmHgToKpa(val)
        ]
      : [val];
  } else {
    const sourceKey = val;
    const item = dataSourceWholeItems.find((item) => item.key == sourceKey);
    return isMultiUnit
      ? item?.tag == 'compound'
        ? [...(item.children ?? [])]
        : [sourceKey, sourceKey]
      : [sourceKey];
  }
};

/**
 * 多数据源的情况下，是否使用相同的数据源
 * @param shape
 * @param deviceType
 * @returns
 */
const whetherUseSameUnitSourceKey = (shape: Shape, deviceType: string) => {
  const sourceKeys = ['weatherCurrentTemperature'];
  const deviceTypes = ['N65', 'M67'];
  return (
    buildAstState.options.buildFor == 'export' &&
    shape.isMultiUnitSource &&
    (sourceKeys.includes(shape.soueceKeys?.[0] ?? '')
      ? deviceTypes.includes(deviceType)
      : false)
  );
};

// export const testIsMultiUnitSource = (shape: Shape) => {
//   return (
//     shape.isMultiUnitSource &&
//     (whetherUseSameUnitSourceKey(
//       shape,
//       buildAstState.data.description?.deviceType ?? ''
//     )
//       ? false
//       : true)
//   );
// };
const needParameter = [
  'DataItemImageNumber',
  'DataItemPointer',
  'DataItemImageValues',
  'DataItemArcProgressBar',
  'DataItemLineProgressBar',
  'DataItemText'
];
const timeSecondSources = ['timeSecond', 'timeSecondHigh', 'timeSecondLow'];
export const findDataItemPointerByRef = (
  resourceAst: Ast,
  refName: string
): Ast | undefined => {
  if (!resourceAst || !resourceAst.children) return undefined;

  const element = resourceAst.children.find(
    (child) => child.attrsMap.name === refName.slice(1)
  );

  if (!element) return undefined;

  if (
    needParameter.includes(element.tag) &&
    timeSecondSources.includes(element.attrsMap.source)
  )
    return element;

  if (element.children?.length) {
    for (const child of element.children) {
      const childRef = child.attrsMap.ref;
      if (childRef) {
        const result = findDataItemPointerByRef(resourceAst, childRef);
        if (result) return result;
      }
    }
  }

  return undefined;
};

// 统一每个样式中的秒针帧率，如果存在多个旋转帧率，则取最小的
export const unifyTimeSecond = (root: Ast) => {
  const resourceAst = root.children.find((ast) => ast.tag == 'Resources');
  if (!resourceAst) return;
  const themeAst = root.children.filter((ast) => ast.tag == 'Theme');

  const children = resourceAst.children ?? [];
  themeAst.forEach((theme) => {
    let unifyParameter = 1001;
    const findRes: Ast[] = [];
    theme.children.forEach((layout) => {
      const { ref } = layout.attrsMap;
      const res = findDataItemPointerByRef(resourceAst, ref);
      if (res) findRes.push(res);
    });
    if (!findRes.length) return;
    // 计算最小秒针parameter
    children.forEach((ast) => {
      if (!findRes.find((val) => val.attrsMap.name == ast.attrsMap.name))
        return;

      const { parameter = 1000 } = ast.attrsMap;
      // 当同时存在多个旋转帧率时，需要取最小的，即当持续旋转和跳针同时存在时使用持续旋转
      unifyParameter = Math.min(unifyParameter, Number(parameter));
    });
    // 如果没有需要统一的参数，则不进行处理
    if (unifyParameter >= 1001) return;

    children.forEach((ast) => {
      if (!findRes.find((val) => val.attrsMap.name == ast.attrsMap.name))
        return;

      const { parameter = 1000 } = ast.attrsMap;
      if (Number(parameter) != unifyParameter) {
        ast.attrsMap['parameter'] = String(unifyParameter);
      }
    });
  });
};

export const AQI_AQL = [
  {
    value: 0,
    level: 0,
    label: '优'
  },
  {
    value: 51,
    level: 1,
    label: '良'
  },
  {
    value: 101,
    level: 2,
    label: '轻度污染'
  },
  {
    value: 151,
    level: 3,
    label: '中度污染'
  },
  {
    value: 201,
    level: 4,
    label: '重度污染'
  },
  {
    value: 301,
    level: 5,
    label: '严重污染'
  }
];
